import React from "react";
import Dropzone from "react-dropzone";
import StackGrid from "react-stack-grid";
import { Image } from "../../../Models/Image";
import "../../../Styles/Upload.scss";
import { fileService } from "../../../Services";
import ImageDropzoneItem from "./ImageDropzoneItem";

const uuid = require("uuid");

type Props = {
  images: Image[];
  onImagesAdded: (items: Image[]) => void;
  onImageDelete: (item: Image) => void;
};

type State = {};

export default class ImageUpload extends React.Component<Props, State> {
  onDrop = (files: File[]) => {
    this.props.onImagesAdded(fileService.filestoImages(files));
  };

  onPaste = (event: React.ClipboardEvent) => {
    this.props.onImagesAdded(fileService.fileListToImages(event.clipboardData.files));
  };

  onItemDelete = (item: Image) => {
    this.props.onImageDelete(item);
  };

  render() {
    const className =
      this.props.images.length === 0 ? "gallery-container-empty" : "gallery-container";

    return (
      <div>
        <h4>Images</h4>
        <div onPaste={this.onPaste}>
          <Dropzone onDrop={this.onDrop} noClick noKeyboard>
            {({ getRootProps }) => (
              <div {...getRootProps()} className={className}>
                {this.props.images.length === 0 ? (
                  <div style={{ color: "gray" }}>
                    Paste images here or click the upload button below.
                  </div>
                ) : (
                  ""
                )}
                <StackGrid columnWidth={180} duration={0}>
                  {this.props.images.map((item: Image, index) => (
                    <ImageDropzoneItem
                      image={item}
                      onDelete={() => this.onItemDelete(item)}
                      key={uuid()}
                    />
                  ))}
                </StackGrid>
              </div>
            )}
          </Dropzone>
        </div>
      </div>
    );
  }
}
